import { updateField } from 'vuex-map-fields'

const SET_DOCUMENTS = (state, payload) => {
  state.documents = payload
}

const PUSH_DOCUMENT = (state, payload) => {
  state.documents.push(payload)
}

const PUSH_DOWNLOAD_HISTORY = (state, payload) => {
  let document = state.documents.find(x => x.id === payload.documentId)
  document.documentDownloads.push(payload)
}

const REMOVE_DOCUMENT = (state, id) => {
  state.documents = state.documents.filter(x => x.id !== id)
}

const SET_MOVEACTION_SUBDIRECTORIES = (state, payload) => {
  state.moveActionSubdirectories = payload
}

const PUT_DOCUMENT = (state, payload) => {
  let index = state.documents.map(x => x.id).indexOf(payload.id)
  state.documents.splice(index, 1, payload)
}

export default {
  updateField,
  SET_DOCUMENTS,
  PUSH_DOCUMENT,
  REMOVE_DOCUMENT,
  SET_MOVEACTION_SUBDIRECTORIES,
  PUSH_DOWNLOAD_HISTORY,
  PUT_DOCUMENT
}
